import {post,get, request} from '../../libs/ajax.js'
import qs from 'qs'

export default {
    //  批量创建-账户列表
    getAccountList:(data,options) => {
        return get('/vivo/batch/get_account_list', data, options);
    },
    // 批量创建-计划列表
    getPlanList:(data,options) => {
        return get('/vivo/batch/get_plan_list', data, options);
    },
    // 批量创建-更新计划
    updatePlanList:(data,options) => {
        return post('/vivo/batch/update_plan_list', data, options);
    },
    // 批量创建-核实信息
    getPlanDetailInfo:(data,options) => {
        return get('/vivo/batch/get_plan_detail_info',data,options);
    },
    // 批量创建-获取产品资质列表
    postQualificationList:(data,options) => {
        return post('/vivo/batch/get_qualification_list',data,options);
    },
    // 批量创建-获取调用计划规格
    getSourcePlanConfig:(data,options) => {
        return get('/vivo/batch/source_plan_config',data,options);
    },
    // 批量创建-获取上传配置
    getUploadConfig(data,options){
        return get('/vivo/batch/get_upload_config',data,options);
    },
    // 批量创建-规格预览、生成预览
    taskPreview:(data,options) => {
        return post('/vivo/batch/preview', data, { timeout: 120* 1000 });
    },
     // 批量创建-规格预览、生成预览 智能投放
     taskAiPreview:(data,options) => {
        return post('/vivo/batch/preview_smart_product', data, { timeout: 120* 1000 });
    },
    // 批量创建-预览信息step4
    taskPreviewInfo(data,options){
        return get('/vivo/batch/preview_info',data,options);
    },
    // 批量创建-预览信息step4
    taskPreviewIdeaList(data,options){
        return get('/vivo/batch/preview_idea_list',data,options);
    },
    // 批量创建-提交任务
    saveTask(data,options){
        return post('/vivo/batch/save',data,options);
    },
    // 批量创建-检查预算
    checkBudget(data,options){
        return get('/vivo/batch/check_budget',data,options);
    },
    // 批量创建-获取产品列表
    getAppList(data,options){
        return get('/vivo/batch/get_app_list',data,options);
    },
    // 批量创建-修改创意 应用标题&应用副标题
    modifyIdeaInfo(data,options){
        return post('/vivo/batch/modify_idea_info',data,options);
    },
    // 批量创建-修改广告监测链接
    modifyAdInfo(data,options){
        return post('/vivo/batch/modify_ad_info',data,options);
    },
    // 批量创建-广告应用素材名称
    putMaterialNameToAdName(data,options){
        return post('/vivo/batch/put_material_name_to_ad_name',data,options);
    },
    // 批量创建-工单列表
    getVivoWorkOrderList(data,options){
        return post('/vivo/batch/get_work_order_list',data,options);
    },
    // 批量创建-工单素材列表
    getWorkOrderMaterialList(data,options ={}){
        return request({
            url: '/vivo/batch/get_work_order_material_list',
            data: qs.stringify(data),
            method: 'post',
            ...options
        });
    },
     // 批量创建-上传素材
     vivoBatchPpload(data,options){
        return request({
            url: '/vivo/batch/upload',
            data,
            method: 'post',
            ...options
        });
    },
    // 任务重试 /td/api/vivo/batch/task_retry
    taskRetry(data,options){
        return post('/vivo/batch/task_retry',data,options);
    },
    uploadByJd(data,options){
        return post('/vivo/batch/upload_by_jd',data,options);
    },
    // 根据视频地址生成图片
    genVideoCoverImg(data,options){
        return post('/vivo/batch/gen_video_cover_img',data,options);
    },

    // 获取智能投放配置
    getSmartProductUploadConfig(data,options){
        return get('/vivo/batch/get_smart_product_upload_config',data,options);
    },
    // 搜索配置
    getWorkOrderSearchConfig(data,options){
        return get('/vivo/batch/get_work_order_search_config',data,options);
    },
    // 获取前n个工单素材
    getWorkOrderMaterialByNum(data,options){
        return post('/vivo/batch/get_work_order_material_by_num',data,options);
    },
    // 获取资质认证链接
    getAppDefaultLink(data,options){
        return post('/vivo/batch/get_default_link',data,options);
    },

    // 智能投放创意列表
    taskAiPreviewIdeaList(data,options){
        return get('/vivo/batch/preview_smart_product_idea_list',data,options);
    },
    // 获取链校验配置
    getDeepLinkConfig(data,options){
        return get('/vivo/batch/deep_link_config',data,options);
    },
    
}
